<template>
  <paginate
    v-if="totalPage > 0"
    v-model="currentPage"
    :page-count="totalPage"
    :page-range="3"
    :margin-pages="2"
    :click-handler="loadPage"
    :prev-text="'‹'"
    :next-text="'›'"
    :container-class="'pagination'"
    prev-link-class="page-link"
    next-link-class="page-link"
    :page-class="'paginate_button page-item'"
    :page-link-class="'page-link'"
    first-last-button
    :first-button-text="'«'"
    :last-button-text="'»'"
  />
</template>

<script>
export default {
  props: ['page', 'totalPage', 'handlerPage'],
  data () {
    return {
      currentPage: 1,
      marginPage: 2,
      pages: []
    };
  },
  watch: {
    page (val) {
      this.currentPage = val;
      this.setPage();
    },
    totalPage () {
      this.setPage();
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setPage();
    });
  },
  methods: {
    setPage () {
      let startPage = this.page - this.marginPage;
      startPage = startPage < 1 ? 1 : startPage;

      let endPage = this.page + this.marginPage;
      endPage = endPage > this.totalPage ? this.totalPage : endPage;

      this.pages = [];
      for (let i = startPage; i <= endPage; i++) {
        this.pages[i - startPage] = i;
      }
    },
    loadPage (val) {
      console.log('loadpage', val);
      this.handlerPage(val);
    }
  }
};
</script>
